/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserMembershipDtoPage } from '../../models/user-membership-dto-page';

export interface ListUserMemberships$Params {
  projectId: string;
  roleIds?: Array<string>;
  usersIds?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'member' | '-member' | 'id' | '-id' | 'projectId' | '-projectId' | 'memberId' | '-memberId' | 'role' | '-role' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listUserMemberships(http: HttpClient, rootUrl: string, params: ListUserMemberships$Params, context?: HttpContext): Observable<StrictHttpResponse<UserMembershipDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listUserMemberships.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('roleIds', params.roleIds, {});
    rb.query('usersIds', params.usersIds, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserMembershipDtoPage>;
    })
  );
}

listUserMemberships.PATH = '/v0/memberships/users';
